import React from "react";
import moment from "moment";

export default function AssessmentDetails(props) {
  let {
    getAssessmentReportByEmpIDData,
    crrSelectedEmp,
    teamName,
    EditDetailsFn,
    EditButtonFn,
    createdAt
  } = props;

  function hexToRgbA(hex, opacity) {
    var c;
    if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
      c = hex.substring(1).split("");
      if (c.length == 3) {
        c = [c[0], c[0], c[1], c[1], c[2], c[2]];
      }
      c = "0x" + c.join("");
      return (
        "rgba(" +
        [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(",") +
        "," +
        opacity +
        ")"
      );
    }
    throw hex;
  }

  let newList = [];
  if (
    getAssessmentReportByEmpIDData &&
    getAssessmentReportByEmpIDData.length > 0
  ) {
    getAssessmentReportByEmpIDData.forEach((element, index) => {
      let getIndex = newList.findIndex(
        (prev) => prev.bucket === element.bucket
      );
      if (getIndex === -1) {
        let temp = {
          bucket: element.bucket,
          colorCode: element.colorCode,
          dimensions: [
            {
              rank: index + 1,
              name: element.dimension,
            },
          ],
        };
        newList.push(temp);
      } else {
        newList[getIndex]["dimensions"].push({
          rank: index + 1,
          name: element.dimension,
        });
      }
    });
  }

  console.log(
    "getAssessmentReportByEmpIDData--->",
    getAssessmentReportByEmpIDData
  );
  console.log("newList--->", newList);

  function getOpacity(rank, item) {
    let total =
      item && item.dimensions && item.dimensions.length > 0
        ? item.dimensions.length
        : 0;
    return (total + 1 - Number(rank)) / (total + 2);
  }


  function getLightColor(bucket) {
    let obj = {
      "THINKING TALENTS": "#FFF0C4",
      "ACTING TALENTS": "#CAE6FC",
      "LEADING TALENTS": "#DBD0EE",
      "RELATING TALENTS": "#D4ECD5"
    }
    return obj && obj[bucket] ? obj[bucket] : "#F2F2F2"
  }

  return (
    <>
      <main className="relative h-full p-10 px-6 space-y-6 bg-white bg-no-repeat page-break">
        
        <div className="flex items-center justify-between w-full px-12 pt-4 pb-2 border-b text-[#212121]/85 italic">
          <h1 className="text-lg font-semibold">
            {EditButtonFn(
              "TalentAssessmentReport",
              "TalentPlusStrengths Assessment"
            )}
          </h1>
          <p className="text-lg font-semibold">
            {crrSelectedEmp && crrSelectedEmp.name
              ? (crrSelectedEmp.name === "Team Overall") ? teamName : crrSelectedEmp.name
              : teamName}{" "}
            {createdAt && crrSelectedEmp.name !== "Team Overall" ? " | " + createdAt : ""}
          </p>
        </div>

        <div className="px-12">
          <div className="w-full space-y-1 page-break">
            <h1 className="text-3xl font-light text-[#212121]">
              {/* <b>{getTitle(element, 1)}</b> */}
              <b>
                {EditButtonFn(
                  "YourTalentPlusThemesByDomain",
                  "TalentPlusStrengths domains and themes"
                )}
              </b>
            </h1>
          </div>

          <div class="grid grid-cols-2 gap-4 mt-6">
            {newList && newList.length > 0
              ? newList.map((item) => (
                <div className="">
                  <div className="">
                    <div className={`px-2 py-2 mb-1.5 font-semibold bg-[#F2F2F2] flex justify-center col-span-2 space-x-2 textcolor`} >
                      <span>{item.bucket}</span>
                    </div>

                    {item && item.dimensions && item.dimensions.length > 0
                      ? item.dimensions.map((element, index2) => (
                        <>

                          {element && element.rank && element.rank <= 5 ?

                            <div className="pl-6 pb-1">
                              <div class="relative flex items-center py-3 bg-[#FFC400] text-black font-semibold text-lg pl-16 pr-12 w-full" style={{
                                background: hexToRgbA(
                                  item && item.colorCode
                                    ? item.colorCode
                                    : "#DDDDDD",
                                  element.rank <= 5 ? "1.0" : "0.24"
                                  // getOpacity(index2+1,item)
                                ),
                                color:
                                  element.rank <= 5
                                    ? item.bucket.trim() === "THINKING TALENTS"
                                      ? "#3D405B"
                                      : "#FFFFFF"
                                    : "#3D405B",
                              }}>
                                <div class="absolute left-0 top-1/2 -translate-y-1/2 -ml-6">
                                  <div class="w-14 h-14 bg-[#FFC400] rounded-full flex items-center justify-center text-black font-bold text-base border-4 border-white" style={{
                                    background: hexToRgbA(
                                      item && item.colorCode
                                        ? item.colorCode
                                        : "#DDDDDD",
                                      element.rank <= 5 ? "1.0" : "0.24"
                                      // getOpacity(index2+1,item)
                                    ),
                                    color:
                                      element.rank <= 5
                                        ? item.bucket.trim() === "THINKING TALENTS"
                                          ? "#3D405B"
                                          : "#FFFFFF"
                                        : "#3D405B",
                                  }}>{element.rank}</div>
                                </div>
                                {element.name}
                              </div>
                            </div>
                            :
                            <div className="pl-6 pb-1">
                              <div style={{
                                background: getLightColor(item.bucket)
                              }} className={`relative flex items-center py-3 text-black font-semibold text-lg pl-16 pr-12 w-full`}>
                                <div className="absolute left-0 top-1/2 -translate-y-1/2 -ml-6">
                                  <div style={{
                                    background: getLightColor(item.bucket)
                                  }} className={`w-14 h-14  rounded-full flex items-center justify-center text-black font-bold text-base border-4 border-white`}>{element.rank}</div>
                                </div>
                                {element.name}
                              </div>
                            </div>
                          }
                        </>
                      ))
                      : null}
                  </div>
                </div>
              ))
              : null}
          </div>

          <div className="hidden grid grid-cols-2 gap-4 mt-6">
            {newList && newList.length > 0
              ? newList.map((item) => (
                <div className="grid grid-cols-2 gap-1 mb-6">
                  <div className={`px-2 py-2 font-medium bg-[#F2F2F2] flex justify-center col-span-2 space-x-2 text-[#3D405B] `} >
                    <span>{item.bucket}</span>
                  </div>
                  {item && item.dimensions && item.dimensions.length > 0
                    ? item.dimensions.map((element, index2) => (
                      <div
                        className="flex flex-col items-center justify-center h-20 gap-1 px-2 py-1 text-center "
                        style={{
                          background: hexToRgbA(
                            item && item.colorCode
                              ? item.colorCode
                              : "#DDDDDD",
                            element.rank <= 5 ? "1.0" : "0.24"
                          ),
                          color:
                            element.rank <= 5
                              ? item.bucket.trim() === "THINKING TALENTS"
                                ? "#3D405B"
                                : "#FFFFFF"
                              : "#3D405B",
                        }}
                      >
                        <p className="text-2xl font-medium">
                          {element.rank}
                        </p>
                        <h1>{element.name}</h1>
                      </div>
                    ))
                    : null}
                </div>
              ))
              : null}
          </div>
        </div>
      </main>
    </>
  );
}
